import React, { useEffect } from 'react';
import { observer } from 'mobx-react-lite';
import {
  betStore,
  gameConfigStore,
  gameResultStore,
  roundInfoStore,
} from '@pascal/pascal-core/shared/core/store';
import {
  BetNotificationWr,
  notificationStore,
  SlowConnectionWr,
  ConnectionPopupsWr,
  UnderMaintenanceWr,
  userInfoStore,
  useTranslation,
  freeBetStore,
  applicationStore,
  useSoundWatcher,
  loadingStore,
} from '@pascal/pascal-core';
import GameMainTop from '../../../../components/oddBallBogComponents/game/gameMainTop';
import GameMainBottom from '../../../../components/oddBallBogComponents/game/gameMainBottom';
import { doBetStore, gameStore, marketsStore } from '../../../../store';
import {
  betAmountValidator,
  changeAutoCashOutOdd,
  changeBetAmount,
} from '../../../../helpers/supporters';
import { autoCashOutDataKeys, minOdd } from '../../../../enums';
import { gameActiveVideoStore } from '../../../../store/gameActiveVideoStore';

const Game = observer(() => {
  const {
    autoBetData,
    betData: { amount, freeBetMinOdd },
    winAmount,
    autoCashOutData: { isOpened, autoCashOutOdd, autoCashOutMaxOdd, isAutoCashOut },
  } = doBetStore;
  const { activeFreeBet } = freeBetStore;
  const {
    limits: { minBet, maxWin },
  } = gameConfigStore;
  const { balance } = userInfoStore;
  const { gameResults } = gameResultStore;
  const { finish, start, process } = gameActiveVideoStore;
  const { finishedOdd, time, isShowGameResultPopup } = gameStore;
  const { totalWin } = marketsStore;
  const { currencySymbolOrCode } = userInfoStore;
  const { gameLoading } = loadingStore;
  const { roundId } = roundInfoStore;
  const { isDemo } = applicationStore;
  const t = useTranslation();

  useSoundWatcher();

  const changeBetInputValue = (functionName) =>
    changeBetAmount(
      { isOpened, autoCashOutOdd: freeBetMinOdd || autoCashOutOdd },
      isDemo,
      functionName,
      doBetStore.setBetAmount,
      gameConfigStore.limits,
      balance,
      amount,
      notificationStore.setNotificationType
    );

  const handleSwitchAutoCashOut = () =>
    doBetStore.updateAutoCashOutData(autoCashOutDataKeys.isOpened, !isOpened);

  const handleChangeAutoCashOutInputValue = (functionName, value) => {
    changeAutoCashOutOdd(
      freeBetMinOdd || minOdd,
      amount,
      maxWin,
      functionName,
      autoCashOutOdd,
      value,
      notificationStore.setNotificationType
    );
  };

  const handleInputBlur = (betAmount) => betAmountValidator(betAmount, gameConfigStore.limits);

  useEffect(() => {
    let timeoutId;
    if (winAmount) {
      timeoutId = setTimeout(() => {
        doBetStore.setWinAmount('');
      }, 2000);
    }

    return () => timeoutId && clearTimeout(timeoutId);
  }, [winAmount]);

  return (
    <div className='oddball-game-wrapper'>
      <BetNotificationWr
        autoCashOutMaxOdd={autoCashOutMaxOdd}
        autoCashOutMinOdd={activeFreeBet?.id ? activeFreeBet?.minOdd : minOdd}
      />
      <UnderMaintenanceWr />
      <SlowConnectionWr />
      <ConnectionPopupsWr />
      <GameMainTop
        t={t}
        results={gameResults}
        totalWin={totalWin}
        winAmount={winAmount}
        timerDuration={time}
        roundId={roundId}
        gameLoading={gameLoading}
        currentOdd={gameStore.oddData}
        finishedOdd={finishedOdd}
        repliedBetData={betStore.repliedBetData}
        isShowGameResultPopup={isShowGameResultPopup}
        isActiveVideo={!start && !finish && !process}
        currencyCode={currencySymbolOrCode}
      />
      <GameMainBottom
        handleChangeAutoBet={doBetStore.updateAutoBetData}
        changeBetInputValue={changeBetInputValue}
        handleSwitchAutoCashOut={handleSwitchAutoCashOut}
        handleChangeAutoCashOutInputValue={handleChangeAutoCashOutInputValue}
        time={time}
        extraProps={{
          handleInputBlur,
          isAutoCashOut,
          autoBetData,
          amount,
          isOpened,
          autoCashOutOdd,
          minBet,
          balance,
        }}
      />
    </div>
  );
});

export default Game;
